import { observable } from '@legendapp/state'
import { syncObservable } from '@legendapp/state/sync'

import { ObservablePersistSecureLocalStorage } from '~in-app/lib/legend-state'

type AuthState = {
  jwt: string | null
  username: string | null
  privileges: Map<string, { divisionIds: string[], firstParentDivisionIds: string[] }> | null
  multiTenancyEnabled: boolean
  operator: {
    id: string
    new: boolean
    static: boolean
  } | null
  division: {
    id: string
    name: string
  } | null
  firstName: string | null
  removeJWTToken: () => void
  clientId?: string | null
}

export const auth$ = observable<AuthState>({
  jwt: null,
  username: null,
  privileges: null,
  multiTenancyEnabled: false,
  operator: null,
  division: null,
  firstName: null,
  clientId: null,
  removeJWTToken: () => {
    auth$.jwt.set(null)
    auth$.username.set(null)
    // @ts-ignore
    auth$.privileges.set(null)
    auth$.multiTenancyEnabled.set(false)
    auth$.operator.set(null)
    auth$.division.set(null)
    auth$.firstName.set(null)
    auth$.clientId.set(null)
  },
})

syncObservable(auth$, {
  persist: {
    name: 'auth',
    plugin: ObservablePersistSecureLocalStorage,
    retrySync: true,
  },
})
